<div class="container">
  <div class="back">
    <button mat-raised-button routerLink="/">
      <i class="material-icons">arrow_back</i>
      Back
    </button>
  </div>

  <div class="score-card-page">
    <div
      class="score-cards-container"
      [ngClass]="{
        'single-card': scoreCardType === ScoreCard.SingleCongressman,
      }"
    >
      @for (scorecard of scoreCards; track scorecard.name) {
        <app-score-card [scorecard]="scorecard" />
      }
    </div>
  </div>
</div>
